<template>
  <div class="z-30 fixed w-full h-full pl-56 pt-20 top-0 left-0">
    <div
      ref="modalbg"
      class="z-30 w-full h-full text-center bg-black/50"
      @click="checkClosing($event)"
    >
      <div class="w-full h-full relative">
        <div
          ref="modalcontent"
          class="z-40 center w-11/12 -ml-16 sm:w-2/3 2xl:w-1/2 text-left bg-white rounded-3xl"
        >
          <div class="w-full h-full relative inline-block">
            <div
              @click="$emit('closeNotification')"
              class="iconborder-modal z-50"
            >
              <font-awesome-icon size="lg" icon="xmark" class="inborder" />
            </div>
            <div class="w-full h-full p-8 px-14">
              <div class="w-full text-center">
                <span class="font-bold text-2xl">Bulk PDF Upload</span>
                
                <div class="mt-6 text-left bg-gray-50 p-4 rounded-lg">
                  <span class="font-semibold text-lg">Wie es funktioniert:</span>
                  <ul class="mt-2 list-disc list-inside text-sm text-gray-600">
                    <li>Lade mehrere CV-PDFs gleichzeitig hoch</li>
                    <li>Die KI analysiert jede Datei und extrahiert Bewerberdaten</li>
                    <li>Jede PDF wird als separate Bewerbung erstellt</li>
                    <li>Dateien werden unverschlüsselt für die KI-Verarbeitung gesendet</li>
                    <li>Bewerbungen werden automatisch dem ausgewählten Job zugeordnet</li>
                  </ul>
                </div>

                <div class="mt-6">
                  <input
                    type="file"
                    ref="fileInput"
                    accept=".pdf"
                    multiple
                    @change="handleFileSelect"
                    class="w-full border-2 border-dashed border-gray-300 rounded-lg p-4 cursor-pointer hover:border-primary transition-colors"
                  />
                  
                  <div v-if="selectedFiles.length > 0" class="mt-4">
                    <span class="font-semibold">Ausgewählte Dateien ({{ selectedFiles.length }}):</span>
                    <div class="mt-2 max-h-40 overflow-y-auto">
                      <div
                        v-for="(file, index) in selectedFiles"
                        :key="index"
                        class="flex items-center justify-between bg-gray-100 p-2 rounded mb-1"
                      >
                        <span class="text-sm truncate">{{ file.name }}</span>
                        <span
                          @click="removeFile(index)"
                          class="text-red-500 cursor-pointer ml-2"
                        >
                          <font-awesome-icon icon="xmark" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-6 flex justify-center gap-4">
                  <button
                    class="relative m-2"
                    @click="uploadFiles"
                  >
                    <div v-if="loading" class="lds-dual-ring"></div>
                    <span v-bind:class="[loading ? 'text-white' : '']">Hochladen und Analysieren</span>
                  </button>
                  <button class="border-primary text-primary m-2" @click="$emit('closeNotification')">
                    Abbrechen
                  </button>
                </div>

                <div v-if="error" class="mt-4 text-red-500 text-center">
                  {{ error }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/API/Business";

export default {
  props: {
    job: Object,
  },
  data() {
    return {
      selectedFiles: [],
      loading: false,
      error: null,
    };
  },
  methods: {
    checkClosing(event) {
      if (event.target == this.$refs.modalbg) {
        this.$emit("closeNotification");
      }
    },
    handleFileSelect(event) {
      this.selectedFiles = Array.from(event.target.files);
      this.error = null;
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },
    uploadFiles() {
      if (this.selectedFiles.length === 0) {
        this.error = "Bitte wähle mindestens eine PDF-Datei aus";
        return;
      }

      if (!this.job || this.job.id === 0) {
        this.error = "Bitte wähle einen Job aus (nicht 'Alle Stellen')";
        return;
      }

      this.loading = true;
      this.error = null;

      API.bulkUploadApplications(this.selectedFiles, this.job.id, (response) => {
        this.loading = false;
        if (response && response.success) {
          this.$emit("uploadComplete", response.created_count);
          this.$emit("closeNotification");
        } else {
          this.error = response?.error || "Fehler beim Hochladen der Dateien";
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
